function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg from 'ha/ui/next/SvgIcon';

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 2.5,
  width: 23,
  height: 3,
  rx: 1,
  ry: 1
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 10.5,
  width: 23,
  height: 3,
  rx: 1,
  ry: 1
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 18.5,
  width: 23,
  height: 3,
  rx: 1,
  ry: 1
});

var SvgNavigationMenuBold = function SvgNavigationMenuBold(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3);
};

export default SvgNavigationMenuBold;